// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const Type200Spritesheets: ISpritesheetMetadata[] = [
  {
    name: 'type2-00-idle',
    metadata: {
      frames: {
        'type2-00-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-idle-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-idle-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-idle-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-idle-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-idle-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/idle.png',
        size: {
          w: 480,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-idle': [
          'type2-00-idle-0',
          'type2-00-idle-1',
          'type2-00-idle-2',
          'type2-00-idle-3',
          'type2-00-idle-4',
          'type2-00-idle-5',
        ],
      },
    },
  },
  {
    name: 'type2-00-run',
    metadata: {
      frames: {
        'type2-00-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-run-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/run.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-run': [
          'type2-00-run-0',
          'type2-00-run-1',
          'type2-00-run-2',
          'type2-00-run-3',
          'type2-00-run-4',
          'type2-00-run-5',
          'type2-00-run-6',
          'type2-00-run-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action2',
    metadata: {
      frames: {
        'type2-00-action2-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action2-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action2.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action2': [
          'type2-00-action2-0',
          'type2-00-action2-1',
          'type2-00-action2-2',
          'type2-00-action2-3',
          'type2-00-action2-4',
          'type2-00-action2-5',
          'type2-00-action2-6',
          'type2-00-action2-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action3',
    metadata: {
      frames: {
        'type2-00-action3-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action3-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action3.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action3': [
          'type2-00-action3-0',
          'type2-00-action3-1',
          'type2-00-action3-2',
          'type2-00-action3-3',
          'type2-00-action3-4',
          'type2-00-action3-5',
          'type2-00-action3-6',
          'type2-00-action3-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action4',
    metadata: {
      frames: {
        'type2-00-action4-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action4-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action4-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action4-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action4-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action4-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action4.png',
        size: {
          w: 480,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action4': [
          'type2-00-action4-0',
          'type2-00-action4-1',
          'type2-00-action4-2',
          'type2-00-action4-3',
          'type2-00-action4-4',
          'type2-00-action4-5',
        ],
      },
    },
  },
  {
    name: 'type2-00-action5',
    metadata: {
      frames: {
        'type2-00-action5-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action5-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action5-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action5-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action5-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action5-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action5.png',
        size: {
          w: 480,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action5': [
          'type2-00-action5-0',
          'type2-00-action5-1',
          'type2-00-action5-2',
          'type2-00-action5-3',
          'type2-00-action5-4',
          'type2-00-action5-5',
        ],
      },
    },
  },
  {
    name: 'type2-00-action6',
    metadata: {
      frames: {
        'type2-00-action6-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action6-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action6-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action6-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action6-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action6.png',
        size: {
          w: 400,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action6': [
          'type2-00-action6-0',
          'type2-00-action6-1',
          'type2-00-action6-2',
          'type2-00-action6-3',
          'type2-00-action6-4',
        ],
      },
    },
  },
  {
    name: 'type2-00-action7',
    metadata: {
      frames: {
        'type2-00-action7-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action7-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action7-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action7-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action7-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action7-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action7.png',
        size: {
          w: 480,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action7': [
          'type2-00-action7-0',
          'type2-00-action7-1',
          'type2-00-action7-2',
          'type2-00-action7-3',
          'type2-00-action7-4',
          'type2-00-action7-5',
        ],
      },
    },
  },
  {
    name: 'type2-00-action8',
    metadata: {
      frames: {
        'type2-00-action8-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action8-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action8-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action8-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action8-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action8-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action8.png',
        size: {
          w: 480,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action8': [
          'type2-00-action8-0',
          'type2-00-action8-1',
          'type2-00-action8-2',
          'type2-00-action8-3',
          'type2-00-action8-4',
          'type2-00-action8-5',
        ],
      },
    },
  },
  {
    name: 'type2-00-action9',
    metadata: {
      frames: {
        'type2-00-action9-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action9-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action9.png',
        size: {
          w: 560,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action9': [
          'type2-00-action9-0',
          'type2-00-action9-1',
          'type2-00-action9-2',
          'type2-00-action9-3',
          'type2-00-action9-4',
          'type2-00-action9-5',
          'type2-00-action9-6',
        ],
      },
    },
  },
  {
    name: 'type2-00-action10',
    metadata: {
      frames: {
        'type2-00-action10-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action10-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action10.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action10': [
          'type2-00-action10-0',
          'type2-00-action10-1',
          'type2-00-action10-2',
          'type2-00-action10-3',
          'type2-00-action10-4',
          'type2-00-action10-5',
          'type2-00-action10-6',
          'type2-00-action10-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action11',
    metadata: {
      frames: {
        'type2-00-action11-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action11-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action11.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action11': [
          'type2-00-action11-0',
          'type2-00-action11-1',
          'type2-00-action11-2',
          'type2-00-action11-3',
          'type2-00-action11-4',
          'type2-00-action11-5',
          'type2-00-action11-6',
          'type2-00-action11-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action12',
    metadata: {
      frames: {
        'type2-00-action12-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action12-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action12.png',
        size: {
          w: 560,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action12': [
          'type2-00-action12-0',
          'type2-00-action12-1',
          'type2-00-action12-2',
          'type2-00-action12-3',
          'type2-00-action12-4',
          'type2-00-action12-5',
          'type2-00-action12-6',
        ],
      },
    },
  },
  {
    name: 'type2-00-action13',
    metadata: {
      frames: {
        'type2-00-action13-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action13-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action13.png',
        size: {
          w: 560,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action13': [
          'type2-00-action13-0',
          'type2-00-action13-1',
          'type2-00-action13-2',
          'type2-00-action13-3',
          'type2-00-action13-4',
          'type2-00-action13-5',
          'type2-00-action13-6',
        ],
      },
    },
  },
  {
    name: 'type2-00-action14',
    metadata: {
      frames: {
        'type2-00-action14-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action14-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action14.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action14': [
          'type2-00-action14-0',
          'type2-00-action14-1',
          'type2-00-action14-2',
          'type2-00-action14-3',
          'type2-00-action14-4',
          'type2-00-action14-5',
          'type2-00-action14-6',
          'type2-00-action14-7',
        ],
      },
    },
  },
  {
    name: 'type2-00-action15',
    metadata: {
      frames: {
        'type2-00-action15-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action15-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action15-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action15.png',
        size: {
          w: 240,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action15': [
          'type2-00-action15-0',
          'type2-00-action15-1',
          'type2-00-action15-2',
        ],
      },
    },
  },
  {
    name: 'type2-00-action16',
    metadata: {
      frames: {
        'type2-00-action16-0': {
          frame: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-1': {
          frame: {
            x: 80,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-2': {
          frame: {
            x: 160,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-3': {
          frame: {
            x: 240,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-4': {
          frame: {
            x: 320,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-5': {
          frame: {
            x: 400,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-6': {
          frame: {
            x: 480,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
        'type2-00-action16-7': {
          frame: {
            x: 560,
            y: 0,
            w: 80,
            h: 80,
          },
          sourceSize: {
            w: 80,
            h: 80,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 80,
            h: 80,
          },
        },
      },
      meta: {
        image: '/sprites/entities/type2-00/action16.png',
        size: {
          w: 640,
          h: 80,
        },
        scale: '1',
      },
      animations: {
        'type2-00-action16': [
          'type2-00-action16-0',
          'type2-00-action16-1',
          'type2-00-action16-2',
          'type2-00-action16-3',
          'type2-00-action16-4',
          'type2-00-action16-5',
          'type2-00-action16-6',
          'type2-00-action16-7',
        ],
      },
    },
  },
];
